import React from 'react';
import { Box, Typography, useTheme, alpha } from '@mui/material';

interface StatCardProps {
    title: string;
    value: number | string;
    backgroundColor?: string;
    backgroundOpacity?: number;
    textColor?: string;
    width?: string | number;
    height?: string | number;
    borderRadius?: string | number;
    className?: string;
}

const StatCard: React.FC<StatCardProps> = ({
    title,
    value,
    backgroundColor = '#ffffff',
    backgroundOpacity = 1,
    textColor = 'white',
    width = 166,
    height = 166,
    borderRadius = 6,
    className,
}) => {
    const theme = useTheme();

    const resolveColor = (color: string) => {
        if (color.includes('.')) {
            const [palette, shade] = color.split('.');
            // @ts-ignore - Accedemos dinámicamente a la paleta
            return theme.palette[palette]?.[shade] || color;
        }
        return color;
    };

    const resolvedBgColor = resolveColor(backgroundColor);

    const bgWithOpacity = backgroundOpacity < 1
        ? alpha(resolvedBgColor, backgroundOpacity)
        : resolvedBgColor;

    const resolvedTextColor = resolveColor(textColor);

    return (
        <Box
            className={`stat-card ${className || ''}`}
            sx={{
                backgroundColor: bgWithOpacity,
                color: resolvedTextColor,
                width,
                height,
                borderRadius,
                padding: theme.spacing(3),
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                transition: 'all 0.3s ease',
                '&:hover': {
                    boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.1)',
                    transform: 'translateY(-2px)',
                },
            }}
        >
            <Typography
                component="div"
                sx={{
                    fontSize: '1.3em',
                    fontWeight: 'medium',
                    mb: 2
                }}
            >
                {title}
            </Typography>

            <Typography
                variant="h3"
                component="div"
                sx={{
                    fontWeight: 'bold',
                    mt: 'auto'
                }}
            >
                {value}
            </Typography>
        </Box>
    );
};

export default StatCard;